const DESKTOP_QUERY = '(min-width: 750px)';

class VideoBanner extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.video.autoplay = false;
      this.video.pause();
      return;
    }

    this.video.addEventListener('playing', () => this.setAttribute('loaded', ''), { once: true });

    const handleApproach = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.load();
    };

    const handleVisibility = (entries) => {
      this.visible = entries[0].isIntersecting;
      if (this.visible) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    };

    this.observers = [
      new IntersectionObserver(handleApproach, { rootMargin: '0px 0px 400px 0px' }),
      new IntersectionObserver(handleVisibility),
    ];
    this.observers.forEach((observer) => observer.observe(this));
  }

  disconnectedCallback() {
    this.observers?.forEach((observer) => observer.disconnect());
    this.observers = null;
  }

  load() {
    if (this.video.src) return;
    const src = window.matchMedia(DESKTOP_QUERY).matches ? this.dataset.videoDesktop : this.dataset.videoMobile;

    if (!src) return;

    this.video.muted = true;
    this.video.src = src;

    this.video.addEventListener(
      'loadeddata',
      () => {
        if (this.visible) this.video.play().catch(() => {});
      },
      { once: true }
    );

    this.video.load();
  }
}

if (!customElements.get('video-banner')) {
  customElements.define('video-banner', VideoBanner);
}
